import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5 12H8M10.5 12H13.5M16 12H19" vectorEffect="non-scaling-stroke" />
	</SVG>
);
